import moment from 'moment'
import {
  convertToBoolean,
  floorToTwoDecimals,
  excludeFromRetail,
  isCoreProduct,
  getSOH,
  getlongtermOOS,
  locationsWithIds,
  imageBaseUrl,
  getCoreRange,
} from '../_utils'
import { formatNumberWithCommas } from './converterSelectors'

export const convertPromotionsListingToAReadableFormat = (list) => {
  const items = []

  Object.values(list).map((promotion) => {
    Object.entries(promotion).map(([promotionID, promotionTitle]) => {
      items.push({
        id: promotionID,
        title: promotionTitle,
        description: '',
      })
    })
  })

  return items

  // return list.reduce((items, item) => {
  //     const { ID, Title, Description } = item.node;
  //     items.push({
  //         id: String(ID),
  //         title: Title,
  //         description: Description,
  //     });
  //     return items;
  // }, []);
}
export const convertProductListingFilters = (list, user) => {
  let newList = {}
  list.map((item) => {
    const { Brand, Region, Country, PType, Style, Varietal } = item._source

    // we will not have id for these filters according to umi
    if (Brand) {
      newList = {
        ...newList,
        Brand: {
          ...newList.Brand,
          [Brand]: { id: Brand, value: Brand, checked: false },
        },
      }
    }
    if (Country) {
      newList = {
        ...newList,
        Country: {
          ...newList.Country,
          [Country]: { id: Country, value: Country, checked: false },
        },
      }
    }
    if (Region) {
      newList = {
        ...newList,
        Region: {
          ...newList.Region,
          [Region]: { id: Region, value: Region, checked: false },
        },
      }
    }
    if (PType) {
      newList = {
        ...newList,
        Type: {
          ...newList.Type,
          [PType]: { id: PType, value: PType, checked: false },
        },
      }
    }
    if (Style) {
      newList = {
        ...newList,
        Style: {
          ...newList.Style,
          [Style]: { id: Style, value: Style, checked: false },
        },
      }
    }
    if (Varietal) {
      newList = {
        ...newList,
        Varietal: {
          ...newList.Varietal,
          [Style]: { id: Style, value: Style, checked: false },
        },
      }
    }
  })
  return newList
}

export const convertPromoDealFilters = (list, user) => {
  let newList = {}
  let filters = {}
  list.forEach((filterItem) => {
    filters[filterItem] = {
      id: filterItem,
      value: filterItem,
      checked: false,
    }
  })

  return filters
}

export const convertProductListingStateFilters = (list, user) => {
  let newList = {}
  list.map((item) => {
    const { brand, region, country, type, style } = item

    // we will not have id for these filters according to umi
    if (brand) {
      newList = {
        ...newList,
        Brand: {
          ...newList.Brand,
          [brand]: { id: brand, value: brand, checked: false },
        },
      }
    }
    if (country) {
      newList = {
        ...newList,
        Country: {
          ...newList.Country,
          [country]: { id: country, value: country, checked: false },
        },
      }
    }
    if (region) {
      newList = {
        ...newList,
        Region: {
          ...newList.Region,
          [region]: { id: region, value: region, checked: false },
        },
      }
    }
    if (type) {
      newList = {
        ...newList,
        Type: {
          ...newList.Type,
          [type]: { id: type, value: type, checked: false },
        },
      }
    }
    if (style) {
      newList = {
        ...newList,
        Style: {
          ...newList.Style,
          [style]: { id: style, value: style, checked: false },
        },
      }
    }
  })
  return newList
}
export const convertProductListingCategories = (list, user) => {
  const newList = {}

  list.forEach((item) => {
    const { WebCategory } = item.node

    if (WebCategory) {
      newList[WebCategory] = {
        id: WebCategory,
        title: WebCategory,
      }
    }
  })

  return newList
}

export const convertThreePlCustomerListingToAReadableFormat = (list, user, supplierWarehouseCode = null) => {
  let newList = []

  list.map((item, index) => {
    //const { node } = item;
    const node = item?.node ? item?.node : item
    const {
      ID,
      InternalItemID,
      Company,
      IsActivated,
      Mobile,
      Email,
      IsThreePLCustomerActive,
      LiquorLicenseNumber,
      EnState,
      EnPostCode,
      DeliveryAddress,
      // ThreePLCustomerType,
      EnTermID,
      IsResidential,
      // RequestAddToGlobalDB,
      DeliveryDays,
      DeliveryTime,
      DeliveryNotes,
      Terms,
    } = node?.[0] || node

    let data = {
      id: ID,
      company: Company,
      externalProductID: '', // TODO
      mobile: Mobile,
      internalItemID: InternalItemID,
      email: Email,
      isActivated: IsActivated,
      isResidential: IsResidential,
      LiquorLicenseNumber: LiquorLicenseNumber,
      enState: DeliveryAddress?.State || EnState,
      enPostCode: DeliveryAddress?.PostalCode || EnPostCode,
      StreetNumber: DeliveryAddress?.StreetNumber,
      StreetName: DeliveryAddress?.StreetName,
      UnitNumber: DeliveryAddress?.UnitNumber,
      Suburb: DeliveryAddress?.Suburb,
      DeliveryAddress: DeliveryAddress,
      Address: DeliveryAddress?.Address,
      preferedDeliveryDay: DeliveryDays,
      preferedDeliveryTime: DeliveryTime,
      deliveryNotes: DeliveryNotes || '',
      // ThreePLCustomerType: ThreePLCustomerType,
      creditTerms: Terms,
      creditTermsID: EnTermID,
      // isGlobalDatabase: RequestAddToGlobalDB,
    }

    newList.push(data)
  })

  return newList
}

export const convertThreePlCreditAccountListingToAReadableFormat = (list) => {
  let newList = []

  list.map((item, index) => {
    //const { node } = item;
    const node = item
    const {
      Balance,
      Debit,
      Credit,
      InvoiceDoc,
      Status,
      TotalCases,
      TransactionID,
      TransactionReference,
      PurchaseDoc,
      Date,
      InvoiceNum,
      Receipt,
      ReceiveDate,
      PurchaseTotal,
    } = node

    let data = {
      balance: Balance ? parseFloat(Balance).toFixed(2) : 0,
      debit: Debit ? parseFloat(Debit).toFixed(2) : '',
      credit: Credit ? parseFloat(Credit).toFixed(2) : '',
      invoiceURL: InvoiceDoc || PurchaseDoc,
      status: Status,
      cases: TotalCases ? parseFloat(TotalCases).toFixed(2) : 0,
      transactionID: TransactionID,
      transactionReference: TransactionReference,
      isCredit: node && node?.hasOwnProperty('PurchaseDoc'), //Credit !== undefined && Credit !== null ? true : false,
      date: Date,
      invoiceNum: InvoiceNum || '',
      receipt: Receipt,
      receiveDate: ReceiveDate,
      purchaseTotal: PurchaseTotal,
    }

    newList.push(data)
  })

  return newList
}

export const convertOrderTemplateListingCategories = (list, user) => {
  const newList = {}
  list.forEach((item) => {
    const { webCategory } = item

    if (webCategory) {
      newList[webCategory] = {
        id: webCategory,
        title: webCategory,
      }
    }
  })

  return newList
}

export const convertProductsAllocationToAReadableFormat = (list, rules) => {
  const newList = list || []
  for (let i = 0; i < rules?.length; i++) {
    const foundProduct = newList.find((product) => product.id == rules[i].BuyableID)
    if (foundProduct && Object.keys(foundProduct).length > 0) {
      const foundIndex = newList.findIndex((obj) => obj.id == foundProduct.id)
      if (foundIndex >= 0) {
        if (newList[foundIndex].sell_by_case) {
          newList[foundIndex].MaxValue = Math.floor(rules[i].MaxValue / newList[foundIndex].wholesale_unit_per_case)
          newList[foundIndex].MinValue = Math.floor(rules[i].MinValue / newList[foundIndex].wholesale_unit_per_case)
        } else {
          newList[foundIndex].MaxValue = Math.floor(rules[i].MaxValue / newList[foundIndex].qty_per_case)
          newList[foundIndex].MinValue = Math.floor(rules[i].MinValue / newList[foundIndex].qty_per_case)
        }
        newList[foundIndex].EndDate = rules[i].EndDate
        newList[foundIndex].StartDate = rules[i].StartDate
        newList[foundIndex].MaxUnitValue = rules[i].MaxValue
        newList[foundIndex].MinUnitValue = rules[i].MinValue
      }
    }
  }
  return newList
}

export const convertSingleProductAllocationToAReadableFormat = (product, rules) => {
  const newProduct = product || {}
  for (let i = 0; i < rules?.length; i++) {
    if (product.id == rules[i].BuyableID) {
      if (newProduct.sell_by_case) {
        newProduct.MaxValue = Math.floor(rules[i].MaxValue / newProduct.wholesale_unit_per_case)
        newProduct.MinValue = Math.floor(rules[i].MinValue / newProduct.wholesale_unit_per_case)
      } else {
        newProduct.MaxValue = Math.floor(rules[i].MaxValue / newProduct.qty_per_case)
        newProduct.MinValue = Math.floor(rules[i].MinValue / newProduct.qty_per_case)
      }
      newProduct.EndDate = rules[i].EndDate
      newProduct.StartDate = rules[i].StartDate
      newProduct.MaxUnitValue = rules[i].MaxValue
      newProduct.MinUnitValue = rules[i].MinValue
    }
  }
  return newProduct
}

export const getRemainingCases = (caseTotal, qty_per_case, unitTotal, MaxUnitValue) => {
  const totalUnits = caseTotal * qty_per_case + unitTotal
  const remainingUnits = MaxUnitValue - totalUnits
  // console.log('remainingUnits remainingCases===',{caseTotal, remainingUnits , totalUnits});
  if (remainingUnits >= 0) {
    return Math.floor((MaxUnitValue - unitTotal) / qty_per_case)
  } else {
    const remained = Math.floor((totalUnits - Math.abs(remainingUnits)) / qty_per_case)
    // console.log('remainingCases===1111',{remained});
    return remained
  }
}

export const getRemainingUnits = (caseTotal, qty_per_case, MaxUnitValue) => {
  const remainingUnits = MaxUnitValue - caseTotal * qty_per_case
  // console.log("remainingUnits remainingCases===",{remainingUnits,caseTotal, qty_per_case, MaxUnitValue})
  return remainingUnits
}

export const getProductsImage = (product) => {
  const { ProductType = '', ContainerType = '', ReSizedProductListingImage = '', ReSizedDefaultImage = '' } = product
  let imageUrl = ''
  if (ReSizedProductListingImage) {
    imageUrl = ReSizedProductListingImage?.includes(`${imageBaseUrl}`)
      ? ReSizedProductListingImage
      : imageBaseUrl + ReSizedProductListingImage
  } else if (ReSizedDefaultImage) {
    imageUrl = ReSizedDefaultImage?.includes(`${imageBaseUrl}`)
      ? ReSizedDefaultImage
      : imageBaseUrl + ReSizedDefaultImage
  } else {
    imageUrl = getProductDefaultImage(ProductType, ContainerType)
  }
  return imageUrl
}

export const getProductDefaultImage = (ProductType, ContainerType) => {
  if (
    (ProductType == '3PL Goods Keg' && ContainerType == 'Keg') ||
    (ProductType == 'Beer Kegs' && ContainerType == 'Keg') ||
    (ProductType == 'Cider Kegs' && ContainerType == 'Keg') ||
    (ProductType == 'Premix Kegs' && ContainerType == 'Keg') ||
    (ProductType == 'Wine Kegs' && ContainerType == 'Keg')
  ) {
    return `${imageBaseUrl}/assets/Default-Product-Images/1.jpg`
  } else if (
    (ProductType == '3PL Goods Pack' && ContainerType == 'Can') ||
    (ProductType == 'Beer Package' && ContainerType == 'Can') ||
    (ProductType == 'Cider Package' && ContainerType == 'Can') ||
    (ProductType == 'Flavoured Cider Package' && ContainerType == 'Can') ||
    (ProductType == 'Non Alcoholic' && ContainerType == 'Can') ||
    (ProductType == 'Premix' && ContainerType == 'Can') ||
    (ProductType == 'Spirits' && ContainerType == 'Can') ||
    (ProductType == 'Wine Package' && ContainerType == 'Can') ||
    (ProductType == 'Craft Beer Package' && ContainerType == 'Can')
  ) {
    return `${imageBaseUrl}/assets/Default-Product-Images/4.jpg`
  } else if (
    (ProductType == 'Wine Package' && ContainerType == 'Bottle') ||
    (ProductType == 'Wine Package' && ContainerType == 'Cask')
  ) {
    return `${imageBaseUrl}/assets/Default-Product-Images/2.jpg`
  } else if (
    (ProductType == '3PL Goods Pack' && ContainerType == 'Bottle') ||
    (ProductType == 'Beer Package' && ContainerType == 'Bottle') ||
    (ProductType == 'Cider Package' && ContainerType == 'Bottle') ||
    (ProductType == 'Flavoured Cider Package' && ContainerType == 'Bottle') ||
    (ProductType == 'Premix' && ContainerType == 'Bottle')
  ) {
    return `${imageBaseUrl}/assets/Default-Product-Images/3.jpg`
  } else if (
    (ProductType == 'Evolution Rewards' && ContainerType == 'Each') ||
    (ProductType == 'Non Alc (Ex CDS)' && ContainerType == 'Bottle') ||
    (ProductType == 'Non Alc (Ex CDS)' && ContainerType == 'Each') ||
    (ProductType == 'Non Alc No GST (Ex CDS)' && ContainerType == 'Bottle') ||
    (ProductType == 'Non Alc No GST (Ex CDS)' && ContainerType == 'Each') ||
    (ProductType == 'Non Alcoholic' && ContainerType == 'Bottle') ||
    (ProductType == 'Non Alcoholic' && ContainerType == 'Each') ||
    (ProductType == 'Non Alcoholic (No GST)' && ContainerType == 'Bottle') ||
    (ProductType == 'Spirits' && ContainerType == 'Bottle') ||
    (ProductType == 'Spirits' && ContainerType == 'Cask') ||
    (ProductType == 'Spirits Inc Wet' && ContainerType == 'Bottle') ||
    (ProductType == 'Sundry' && ContainerType == 'Bottle') ||
    (ProductType == 'Sundry' && ContainerType == 'Each')
  ) {
    return `${imageBaseUrl}/assets/Default-Product-Images/5.jpg`
  } else {
    return `${imageBaseUrl}/assets/Default-Product-Images/1.jpg`
  }
}

export const findPriceDifference = (arr1 = [], arr2 = []) => {
  if (arr1.length == 0 || arr2.length == 0) {
    return []
  }
  return arr1?.filter((obj1) => {
    return arr2?.find(
      (obj2) =>
        obj2?.BuyableID == obj1?.BuyableID &&
        (+obj1?.PriceBris !== +obj2?.PriceBris ||
          +obj1?.PriceCns !== +obj2?.PriceCns ||
          +obj1?.PriceAdl !== +obj2?.PriceAdl ||
          +obj1?.PriceSyd !== +obj2?.PriceSyd ||
          +obj1?.PriceMel !== +obj2?.PriceMel)
    )
  })
}

export const getModifiedPrice = (orignal = [], modified = []) => {
  if (modified.length == 0) {
    return []
  }

  let newArray = []

  for (let i = 0; i < modified.length; i++) {
    let foundProduct = orignal.find((item) => item.BuyableID == modified[i].BuyableID)
    if (foundProduct?.PriceAdl !== modified[i]?.PriceAdl) {
      newArray.push({
        BuyableID: modified[i]?.BuyableID,
        PromotionID: modified[i]?.PromotionIDAdl,
        Caseamount: Number(modified[i]?.PriceAdl),
      })
    }
    if (foundProduct?.PriceBris !== modified[i]?.PriceBris) {
      newArray.push({
        BuyableID: modified[i]?.BuyableID,
        PromotionID: modified[i]?.PromotionIDBris,
        Caseamount: Number(modified[i]?.PriceBris),
      })
    }
    if (foundProduct?.PriceMel !== modified[i]?.PriceMel) {
      newArray.push({
        BuyableID: modified[i]?.BuyableID,
        PromotionID: modified[i]?.PromotionIDMel,
        Caseamount: Number(modified[i]?.PriceMel),
      })
    }
    if (foundProduct?.PriceSyd !== modified[i]?.PriceSyd) {
      newArray.push({
        BuyableID: modified[i]?.BuyableID,
        PromotionID: modified[i]?.PromotionIDSyd,
        Caseamount: Number(modified[i]?.PriceSyd),
      })
    }
    if (foundProduct?.PriceCns !== modified[i]?.PriceCns) {
      newArray.push({
        BuyableID: modified[i]?.BuyableID,
        PromotionID: modified[i]?.PromotionIDCns,
        Caseamount: Number(modified[i]?.PriceCns),
      })
    }
  }
  return newArray
}

export const mergeProductsListingWithPrices = (prices = [], products = []) => {
  if (prices.length == 0) {
    return products
  }
  let newList = products || []
  for (let i = 0; i < newList?.length; i++) {
    let foundProduct = prices.find((item) => item.BuyableID == newList[i].id)
    if (foundProduct && Object.keys(foundProduct).length > 0) {
      newList[i].PriceAdl = foundProduct.PriceAdl !== '' ? foundProduct.PriceAdl : ''
      newList[i].PriceBris = foundProduct.PriceBris !== '' ? foundProduct.PriceBris : ''
      newList[i].PriceCns = foundProduct.PriceCns !== '' ? foundProduct.PriceCns : ''
      newList[i].PriceMel = foundProduct.PriceMel !== '' ? foundProduct.PriceMel : ''
      newList[i].PriceSyd = foundProduct.PriceSyd !== '' ? foundProduct.PriceSyd : ''
    } else {
      newList[i].PriceAdl = '0.00'
      newList[i].PriceBris = '0.00'
      newList[i].PriceCns = '0.00'
      newList[i].PriceMel = '0.00'
      newList[i].PriceSyd = '0.00'
    }
  }
  return newList
}

export const filterCurrentAvailableProductsPrices = (prices = [], products = []) => {
  if (products?.length == 0) {
    return []
  }

  let remained = []
  for (let i = 0; i < products?.length; i++) {
    let foundProduct = prices?.find((item) => item?.BuyableID == products[i])
    console.log('filterCurrentAvailableProductsPrices prices , products', {
      id: products[i],
      products,
      foundProduct,
      prices,
    })
    if (foundProduct && Object.keys(foundProduct).length > 0) {
      let obj = {
        BuyableID: foundProduct?.BuyableID,
        PriceAdl: (foundProduct?.PriceAdl).toFixed(2),
        PriceBris: (foundProduct?.PriceBris).toFixed(2),
        PriceCns: (foundProduct?.PriceCns).toFixed(2),
        PriceMel: (foundProduct?.PriceMel).toFixed(2),
        PriceSyd: (foundProduct?.PriceSyd).toFixed(2),
      }
      remained.push(obj)
    } else {
      let obj = {
        BuyableID: products[i],
        PriceAdl: '0.00',
        PriceBris: '0.00',
        PriceCns: '0.00',
        PriceMel: '0.00',
        PriceSyd: '0.00',
      }
      remained.push(obj)
    }
  }
  return remained
}

export const convertProductsListingToAReadableFormat = (list, user, supplierWarehouseCode = null) => {
  const newList = []
  const isNewDateMarking = moment().subtract({ days: 84 })
  console.log('user')
  console.log(user)
  const getNumber = ({ value, defaultValue }) => {
    const num = parseInt(value, 10)
    return isNaN(num) ? defaultValue : num
  }

  list.map((item, index) => {
    // const { node } = item;
    const node = item?.node ? item?.node : item
    const {
      ID,
      InternalItemID,
      ReSizedDefaultImage,
      ReSizedProductListingImage,
      Title,
      WebCategory,
      Brand,
      BrandCountry,
      BrandRegion,
      LiquorStyle,
      Varietal,
      ContainerType,
      ProductType,
      CasePrice,
      CaseRRP,
      DisplayPrice,
      DisplayRRP,
      WholesaleUnitsPerCase,
      ItemsInCase,
      SellByPackageOnly,
      SoldAt,
      StockForAdelaide,
      StockForMelbourne,
      StockForSydney,
      StockForBrisbane,
      StockForCairns,
      URLSegment,
      UnitPrice,
      UnitRRP,
      EnCreated,
      HasCocktails,
      LoyaltyPoints,
      SupplierLoyaltyPoints,
      BonusLoyaltyPoints,
      PointsExcludedFromRetail,
      WetTax = 0,
      SplitPackSize,
      CaseCostMelbourne,
      CaseCostSydney,
      CaseCostAdelaide,
      CaseCostBrisbane,
      CaseCostCairns,
      CombinedStock = 0,
      TranslationRedemptionID = 0,
      Sort,
      LongtermOOS,
      Abv,
      CasesPerLayer,
      CasesPerPallet,
      ItemWeight,
      MLPerunit,
      Supplier,
      SupplierExternalID,
      SplitCaseSurchargesJSON,
      IsCoreRange,
      MiraklProduct,
    } = node?.[0] || node
    // let defaultImage =  getProductDefaultImage(ProductType, ContainerType)
    // let image = ReSizedProductListingImage || ReSizedDefaultImage || defaultImage
    // if (image !== defaultImage && window?.isLocalhost) {
    //   image = window?.baseURL + image
    // }
    const paramsArr = node?.[0] || node
    const image = getProductsImage(paramsArr)

    const sohRaw = {
      vic: StockForMelbourne || 0,
      nsw: StockForSydney || 0,
      sa: StockForAdelaide || 0,
      qld: StockForBrisbane || 0,
      wa: StockForCairns || 0,
    }

    if (TranslationRedemptionID == '9907276') {
      sohRaw['all'] = CombinedStock || 0
    }

    let selectedLocation = ''
    if (window.is3PLSupplier && window.currentWarehouseID) {
      let found = locationsWithIds.find((item) => item.id == window.currentWarehouseID)
      selectedLocation = found.location
    }
    const warehouseCode = selectedLocation || supplierWarehouseCode || window?.warehouseCode
    const isCore = isCoreProduct(warehouseCode, SoldAt)
    const isCoreRange = getCoreRange(user?.enLocationID, IsCoreRange)
    const data = {
      id: ID,
      productID: ID,
      externalProductID: '', // TODO
      url_slug: URLSegment,
      sku: InternalItemID,
      wetTax: WetTax ? parseFloat(WetTax) : 0,
      splitPackSize: SplitPackSize,
      caseCostMelbourne: CaseCostMelbourne,
      caseCostSydney: CaseCostSydney,
      caseCostAdelaide: CaseCostAdelaide,
      caseCostBrisbane: CaseCostBrisbane,
      caseCostCairns: CaseCostCairns,
      hasCocktails: HasCocktails || false,
      hasDiscount: false,
      isNew: moment(EnCreated).isSameOrAfter(isNewDateMarking, 'day'),
      case_price: CasePrice,
      unit_price: UnitPrice,
      isSpecial: CaseRRP > 0,
      wholesale_unit_per_case: WholesaleUnitsPerCase,
      qty_per_case: ItemsInCase,
      image,
      title: Title,
      categories: [], // TODO
      isCore,
      translationRedemptionID: TranslationRedemptionID,
      soh: getSOH(isCore, warehouseCode, sohRaw, isCoreRange, TranslationRedemptionID),
      // soh: StockForMelbourne || 0, // Default this to melbourne, everything will be recalculated later
      sohRaw,
      // sell_by_case: UnitPrice == 0,
      sell_by_case: SellByPackageOnly,
      brand: Brand,
      country: BrandCountry,
      region: BrandRegion,
      style: LiquorStyle,
      varietal: Varietal,
      container: ContainerType,
      type: '', // TODO
      created: EnCreated || '0000-00-00',
      lastEdited: '',
      expiredOn: moment().add(15, 'm'),
      soldAt: SoldAt,
      loyaltyPoints: getNumber({ value: LoyaltyPoints, defaultValue: 0 }),
      supplierLoyaltyPoints: excludeFromRetail(PointsExcludedFromRetail)
        ? 0
        : getNumber({ value: SupplierLoyaltyPoints, defaultValue: 0 }),
      bonusLoyaltyPoints: excludeFromRetail(PointsExcludedFromRetail)
        ? 0
        : getNumber({ value: BonusLoyaltyPoints, defaultValue: 0 }),
      // Prices (New Elvanti Paramount)
      // case_discount: CaseRRP > 0 ? CaseRRP - CasePrice : 0,
      // case_price: CasePrice,
      // case_price_tax: 0,
      // unit_discount: UnitRRP > 0 ? UnitRRP - UnitPrice : 0,
      // unit_price: UnitPrice,
      // unit_price_tax: 0,
      order: index, // the order for the sorted search result products
      webCategory: WebCategory,
      Sort: Sort,
      coldStorage: 'yes',
      longtermOOS: LongtermOOS?.edges ? getlongtermOOS(LongtermOOS.edges, isCore, warehouseCode, sohRaw) : null,
      abv: Abv,
      cases_per_layer: CasesPerLayer || 0,
      cases_per_pallet: CasesPerPallet || 0,
      case_weight_in_kg: ItemWeight || '',
      ml_per_unit: MLPerunit || '',
      supplierName: Supplier,
      supplierID: SupplierExternalID,
      splitCaseSurchargesJSON: JSON.parse(SplitCaseSurchargesJSON || '{}'),
      isCoreRange: isCoreRange,
      miraklProduct: MiraklProduct,
    }

    if (data.sell_by_case) {
      // data.unit_price = null;
    }

    // let data = {
    //     // ProductVariationID
    //     id: String(ProductVariationID),
    //     productID: String(ProductVariationProductID),
    //     externalProductID: ProductExternalItemID,
    //     url_slug: ProductRelativeLink,
    //     sku: getProductSku(ProductVariationInternalItemID),
    //     hasCocktails: convertToBoolean(ProductHasCocktails),
    //     hasDiscount: convertToBoolean(ProductHasPromotions),
    //     isNew: convertToBoolean(ProductOnNewArrival),
    //     isSpecial: convertToBoolean(ProductOnSpecial),
    //     qty_per_case: Number(ProductConsumableUnitsPerCase),
    //     image: ProductReSizedProductListingImage || 'http://placehold.it/240x240',
    //     title: ProductVariationProductTitle,
    //     categories: (typeof(ProductCategoriesMap) != 'undefined') ? getProductCategoryIDArray(ProductCategoriesMap) : [],
    //     soh: getProductSoh(ProductVariationWarehouseStocksMap, user.warehouse),
    //     sell_by_case: convertToBoolean(ProductSellByCaseOnly),
    //     case_price: Number(BulkPrice), // TODO: replace with the discounted price once backend has the info
    //     unit_price: Number(SalePrice),
    //     brand: ProductBrand,
    //     country: BrandCountry,
    //     region: ProductBrandRegion,
    //     // brand: ProductBrandID,
    //     // country: BrandCountryID,
    //     // region: ProductBrandRegionID,
    // };
    //
    // if (data.sell_by_case) {
    //     data.unit_price = null;
    // }

    newList.push(data)
  })

  return newList
}
// export const isInDeal = (internalItemID) => {
//   return (dispatch, getState) => {
//     const store = getState()

//     const { user } = store
//     const customerPromo = user?.customerPromo
//     const promoDeals = user?.promoDeals

//     if (customerPromo[internalItemID] && customerPromo[internalItemID]['Featured']) {
//       return true
//     }
//     if (
//       _.some(promoDeals, function (go) {
//         return go === internalItemID
//       })
//     ) {
//       return true
//     }

//     return false
//   }
// }
export const convertSaleQuoteItemsToAReadableFormat = (list, user) => {
  const Code = list?.Customer?.Warehouse?.Code
  const newList = []
  const isNewDateMarking = moment().subtract({ days: 14 })

  const getNumber = ({ value, defaultValue }) => {
    const num = parseInt(value, 10)
    return isNaN(num) ? defaultValue : num
  }

  const getCaseDiscountPercentageExWet = (item) => {
    const wholesaleListPrice = getWholesaleListPrice(item)
    const caseDiscountPercentageExWet = (item.supplier_discount_per_case / wholesaleListPrice) * 100
    if (isNaN(caseDiscountPercentageExWet)) {
      return 0.0
    }
    return parseFloat(caseDiscountPercentageExWet).toFixed(2)
  }

  const getWholesaleListPrice = (row) => {
    // FRONTLINE (EX WET) = CasePrice -> FRONTLINE (EX WET) * (1 + WET)
    const { frontline_case_price, wet_tax } = row
    const wholeSaleListPrice = frontline_case_price * (1 + parseFloat(wet_tax))
    return parseFloat(wholeSaleListPrice).toFixed(2)
  }
  const getSupplierDiscountPerCase = (row) => {
    const { supplier_discount_per_case } = row
    const CalculatedSupplierDiscountPerCase = supplier_discount_per_case

    return parseFloat(CalculatedSupplierDiscountPerCase).toFixed(2)
  }

  const getUnitPrice = (item) => {
    const { frontline_case_price, supplier_discount_per_case, wet_tax, case_discount, wholesale_unit_per_case } = item

    // Calculation
    // CASE PRICE = (FRONTLINE (EX WET) - SUPPLIER DISCOUNT PER CASE - Paramount Discount) * (1 + WET)
    const casePrice = (frontline_case_price - supplier_discount_per_case - case_discount) * (1 + parseFloat(wet_tax))
    let calculatedUnitPrice = 0

    if (casePrice) {
      // UNIT PRICE = CASE PRICE / WHOLESALE UNITS PER CASE

      calculatedUnitPrice = casePrice / parseFloat(wholesale_unit_per_case)
    }

    return parseFloat(calculatedUnitPrice).toFixed(2)
  }
  const getCustomerCostCase = (item) => {
    const { caseCostMelbourne, caseCostSydney, caseCostAdelaide, caseCostBrisbane, caseCostCairns } = item
    if (Code === 'MELBOURNE') {
      return caseCostMelbourne
    } else if (Code === 'SYDNEY') {
      return caseCostSydney
    } else if (Code === 'ADELAIDE') {
      return caseCostAdelaide
    } else if (Code === 'BRISBANE' && parseInt(caseCostBrisbane)) {
      return caseCostBrisbane
    } else if (Code === 'CAIRNS' && parseInt(caseCostCairns)) {
      return caseCostCairns
    }
    return caseCostMelbourne
  }

  const getCostCase = (item) => {
    // COST(UNIT) = COST CASE / WHOLESALE UNITS PER CASE
    const costCase = getCustomerCostCase(item)

    const calculatedCostCase = costCase / item.wholesale_unit_per_case

    if (isNaN(calculatedCostCase)) {
      return 0.0
    }

    return parseFloat(calculatedCostCase).toFixed(2)
  }

  const getMarginPercentageInteger = (item) => {
    const { frontline_case_price, wholesale_unit_per_case, paramount_discount } = item

    // CASE MARGIN = (FRONTLINE (EX WET) - Paramount Discount - case_cost)
    const case_cost = getCustomerCostCase(item)
    const case_margin = frontline_case_price - paramount_discount - case_cost

    return case_margin / wholesale_unit_per_case

    // const unit_price = frontline_case_price / wholesale_unit_per_case

    // const marginPercentage = (unit_margin / unit_price) * 100
    // if (isNaN(marginPercentage)) {
    //   return 0.0
    // }
    // return parseFloat(marginPercentage).toFixed(2)
  }
  const getMarginValuePercentage = (margin, item) => {
    const { frontline_case_price, wholesale_unit_per_case, paramount_discount } = item

    const unit_price = (frontline_case_price - paramount_discount) / wholesale_unit_per_case

    const marginPercentage = (margin / unit_price) * 100
    if (isNaN(marginPercentage)) {
      return 0.0
    }
    return parseFloat(marginPercentage).toFixed(2)
  }

  const getMargin = (item) => {
    // Calculation
    // UNIT MARGIN = (front-line - paramount discount - case cost)/whoesale units per case

    const { frontline_case_price, wholesale_unit_per_case, paramount_discount } = item

    // CASE MARGIN = (FRONTLINE (EX WET) - Paramount Discount - case_cost)
    const case_cost = getCustomerCostCase(item)
    const case_margin = frontline_case_price - paramount_discount - case_cost

    const unit_margin = case_margin / wholesale_unit_per_case

    if (isNaN(unit_margin)) {
      return 0.0
    }
    return parseFloat(unit_margin).toFixed(2)
  }
  const getCostUnit = (item) => {
    // COST(UNIT) = COST CASE / WHOLESALE UNITS PER CASE
    const costCase = getCustomerCostCase(item)

    const calculatedCostCase = costCase / item.wholesale_unit_per_case

    if (isNaN(calculatedCostCase)) {
      return 0.0
    }

    return parseFloat(calculatedCostCase).toFixed(2)
  }
  const getGp = (item) => {
    // this needs to be change later
    if (item.gp == 3.5) {
      return 3.5
    }
    //  GP% = MARGIN / COST(UNIT)
    const margin = getMargin(item)

    const cost_unit = getCostUnit(item)
    const calc1 = margin / cost_unit
    const calculatedGp = calc1 * 100
    if (isNaN(calculatedGp)) {
      return 0.0
    }
    return parseFloat(calculatedGp).toFixed(2)
  }

  list.SalesQuoteItems.edges.map((item, index) => {
    const {
      ID,
      InternalItemID,
      ReSizedDefaultImage,
      ReSizedProductListingImage,
      Title,
      WebCategory,
      Brand,
      BrandCountry,
      BrandRegion,
      LiquorStyle,
      Varietal,
      CasePrice,
      CaseRRP,
      DisplayPrice,
      DisplayRRP,
      WholesaleUnitsPerCase,
      ItemsInCase,
      SellByPackageOnly,
      SoldAt,
      StockForAdelaide,
      StockForMelbourne,
      StockForSydney,
      StockForBrisbane,
      StockForCairns,
      URLSegment,
      UnitPrice,
      UnitRRP,
      EnCreated,
      HasCocktails,
      LoyaltyPoints,
      SupplierLoyaltyPoints,
      BonusLoyaltyPoints,
      PointsExcludedFromRetail,
      // WetTax,
      SplitPackSize,
      CaseCostMelbourne,
      CaseCostSydney,
      CaseCostAdelaide,
      CaseCostBrisbane,
      CaseCostCairns,
      Sort,
      ProductType,
      ContainerType,
      IsCoreRange,
      Supplier,
    } = item?.node[0]?.Product || item?.node?.Product

    const paramsArr = item?.node[0]?.Product || item?.node?.Product
    const image = getProductsImage(paramsArr)
    const sohRaw = {
      vic: StockForMelbourne || 0,
      nsw: StockForSydney || 0,
      sa: StockForAdelaide || 0,
      qld: StockForBrisbane || 0,
      wa: StockForCairns || 0,
    }

    const warehouseCode = window?.warehouseCode
    const isCore = isCoreProduct(warehouseCode, SoldAt)
    const isCoreRange = getCoreRange(user?.enLocationID, IsCoreRange)
    const {
      CompetitorPrice,
      CompetitorEmail,
      CompetitorPriceDisabled,
      Frequency,
      Quantity,
      Savings,
      SupplierDiscountPerCase,
      SaleQuoteItemUnitPrice,
      WetTax = 0,
      ParamountDiscount = 0,
      FrontLinePrice = 0,
      Notes = '',
      WholesaleListPrice = 0,
      Gp = 0,
    } = item?.node[0] || item?.node

    const saleQuoteID = item?.node[0]?.ID || item?.node?.ID

    const data = {
      id: saleQuoteID,
      productID: ID,
      externalProductID: '', // TODO
      url_slug: URLSegment,
      sku: InternalItemID,
      wetTax: WetTax ? parseFloat(WetTax) : 0,
      splitPackSize: SplitPackSize,
      hasCocktails: HasCocktails || false,
      hasDiscount: false,
      isNew: moment(EnCreated).isSameOrAfter(isNewDateMarking, 'day'),
      isSpecial: CaseRRP > 0,
      wholesale_unit_per_case: WholesaleUnitsPerCase,
      qty_per_case: ItemsInCase,
      image,
      title: Title,
      categories: [], // TODO
      isCore,
      soh: getSOH(isCore, warehouseCode, sohRaw, isCoreRange),
      // soh: StockForMelbourne || 0, // Default this to melbourne, everything will be recalculated later
      sohRaw,
      // sell_by_case: UnitPrice == 0,
      sell_by_case: SellByPackageOnly,
      brand: Brand,
      country: BrandCountry,
      region: BrandRegion,
      style: LiquorStyle,
      varietal: Varietal,
      type: '', // TODO
      created: EnCreated || '0000-00-00',
      lastEdited: '',
      expiredOn: moment().add(15, 'm'),
      soldAt: SoldAt,
      loyaltyPoints: getNumber({ value: LoyaltyPoints, defaultValue: 0 }),
      supplierLoyaltyPoints: excludeFromRetail(PointsExcludedFromRetail)
        ? 0
        : getNumber({ value: SupplierLoyaltyPoints, defaultValue: 0 }),
      bonusLoyaltyPoints: excludeFromRetail(PointsExcludedFromRetail)
        ? 0
        : getNumber({ value: BonusLoyaltyPoints, defaultValue: 0 }),

      order: index, // the order for the sorted search result products
      webCategory: WebCategory,
      competitorPrice: parseFloat(CompetitorPrice).toFixed(2),
      competitorEmail: CompetitorEmail,
      frequency: Frequency,
      salesQtyPerWeek: Quantity,
      savings: Savings,
      paramount_discount: parseFloat(ParamountDiscount).toFixed(2),
      supplier_discount_per_case: parseFloat(SupplierDiscountPerCase).toFixed(2),
      // supplier_discount_per_case_percentage: parseFloat(caseDiscountPercentageExWet).toFixed(2),
      saleQuoteItemUnitPrice: SaleQuoteItemUnitPrice,
      frontline_case_price: parseFloat(FrontLinePrice).toFixed(2),
      case_discount: parseFloat(ParamountDiscount).toFixed(2),
      wet_tax: WetTax ? parseFloat(WetTax) : 0, // WetTax,
      // wholesale_list_price: WholesaleListPrice,
      caseCostMelbourne: CaseCostMelbourne,
      caseCostSydney: CaseCostSydney,
      caseCostAdelaide: CaseCostAdelaide,
      caseCostBrisbane: CaseCostBrisbane,
      caseCostCairns: CaseCostCairns,
      warehouseCode: Code,
      gp: Gp,
      CompetitorPriceDisabled: CompetitorPriceDisabled,
      isCompetitorPrice: false,
      Sort: Sort,
      Notes: Notes,
      supplierName: Supplier,
    }
    data.supplier_discount_per_case_percentage = getCaseDiscountPercentageExWet(data)
    data.calculatedUnitPrice = getUnitPrice(data)
    data.wholesale_list_price = getWholesaleListPrice(data)
    data.cost_unit = getCostCase(data)
    data.margin = getMargin(data)
    data.marginPercentage = getMarginValuePercentage(getMarginPercentageInteger(data), data)
    data.gp = getGp(data)
    data.CalculatedSupplierDiscountPerCase = getSupplierDiscountPerCase(data)
    if (data.sell_by_case) {
      // data.unit_price = null;
    }

    newList.push(data)
  })

  return newList
}

export const convertCocktailTemplateToAReadableFormat = (list, user, products) => {
  const newList = []
  list.map((item) => {
    const BuyableID = item?.node?.BuyableID
    newList.push({
      id: BuyableID,
    })
  })

  return newList
}

export const convertPoductTemplateToAReadableFormat = (list, user, products) => {
  const newList = []
  const productsBasedOnProductID = {}
  Object.entries(products).map(([key, item]) => {
    const { productID } = item
    productsBasedOnProductID[productID] = item

    list.map((item) => {
      const { BuyableID } = item?.node
      const { id } = productsBasedOnProductID[key]
      if (id == BuyableID) {
        newList.push({
          id: String(BuyableID),
          isAddToTemplate: true,
        })
      }
    })
  })

  return newList
}

export const convertCocktailNotificationToAReadableFormat = (list, user, products) => {
  const newList = []
  if (!list || list.length === 0) {
    return []
  }
  list.map((item) => {
    const ID = item

    newList.push({
      id: Number(item.ID),
    })
  })

  return newList
}

export const convertPoductNotificationToAReadableFormat = (list, user, products) => {
  const newList = []
  if (!list || list.length === 0) {
    return []
  }

  const productsBasedOnProductID = {}
  Object.entries(products).map(([key, item]) => {
    const { productID } = item
    productsBasedOnProductID[productID] = item

    list.map((item) => {
      const { ID } = item
      const { id } = productsBasedOnProductID[key]
      if (id == ID) {
        newList.push({
          id: String(ID),
          isNotify: true,
        })
      }
    })
  })

  return newList
}

// export const convertProductsPricesToAReadableFormat = (list, user, products) => {
export const convertProductsPricesToAReadableFormat = (data, ignoreDiscount = false, isSaleQuote = false) => {
  if (!data || data.length === 0) {
    return []
  }

  return data.map((discountData) => {
    let {
      Discount,
      BuyableID,
      UnitPrice,
      CasePrice,
      DiscountedCasePrice,
      DiscountedUnitPrice,
      UnitDiscount = 0,
      QtyPerCase = 1,
      WholesaleUnitsPerCase = 1,
      SupplierDiscountPerCase = 0,
      ParamountDiscount = 0,
      WetTax = 0,
      FrontLineCasePrice = 0,
      Featured = 0,
      unitSurcharge = 0,
    } = discountData

    CasePrice = floorToTwoDecimals(CasePrice)
    UnitPrice = floorToTwoDecimals(UnitPrice)
    DiscountedCasePrice = floorToTwoDecimals(DiscountedCasePrice)
    DiscountedUnitPrice = floorToTwoDecimals(DiscountedUnitPrice)

    if (ignoreDiscount === true) {
      return {
        id: String(BuyableID),
        case_discount: 0,
        case_price: floorToTwoDecimals(CasePrice),
        case_price_tax: 0,
        unit_discount: 0,
        unit_price: floorToTwoDecimals(UnitPrice),
        unit_price_tax: 0,
        hasDiscount: false,
      }
    } else {
      /* Calculate Surcharge on unit price (Ex Wet)*/
      let wetExclCasePrice = DiscountedCasePrice / (1 + WetTax)
      let wetInclUnitPrice = (wetExclCasePrice / WholesaleUnitsPerCase) * (1 + unitSurcharge) * (1 + WetTax)

      const caseDiscount = Discount

      const unitDiscount = UnitDiscount || 0
      const hasDiscount = caseDiscount > 0 || unitDiscount > 0

      let unit_price = UnitPrice
      if (DiscountedUnitPrice) {
        unit_price = floorToTwoDecimals((DiscountedCasePrice - caseDiscount) / WholesaleUnitsPerCase)
      }

      // const discounted_case_price = DiscountedCasePrice - caseDiscount * (1 + WetTax)
      // const cal_case_price = CasePrice - caseDiscount * (1 + WetTax)
      const discounted_case_price = DiscountedCasePrice - caseDiscount * (1 + 0)
      const discounted_unit_price = (discounted_case_price / WholesaleUnitsPerCase) * (1 + unitSurcharge)

      const cal_case_price = CasePrice - caseDiscount * (1 + 0)
      const cal_unit_price = (cal_case_price / WholesaleUnitsPerCase) * (1 + unitSurcharge)

      return {
        id: String(BuyableID),
        case_discount: floorToTwoDecimals(caseDiscount),
        supplier_discount_per_case: parseFloat(SupplierDiscountPerCase).toFixed(2),
        paramount_discount: parseFloat(ParamountDiscount).toFixed(2),
        // wet_tax: 0, // floorToTwoDecimals(0),
        wet_tax: isSaleQuote && WetTax ? parseFloat(WetTax) : 0,
        case_price: floorToTwoDecimals(DiscountedCasePrice),
        case_price_tax: 0,
        unit_discount: unitDiscount,
        unit_price: floorToTwoDecimals(wetInclUnitPrice),
        unit_price_tax: 0,
        hasDiscount: hasDiscount,
        hasFeaturedDiscount: hasDiscount && Featured,
        discounted_case_price: floorToTwoDecimals(discounted_case_price),
        discounted_unit_price: floorToTwoDecimals(discounted_unit_price),
        frontline_case_price: floorToTwoDecimals(FrontLineCasePrice),
        cal_case_price: floorToTwoDecimals(cal_case_price),
        cal_unit_price: floorToTwoDecimals(cal_unit_price),
        unitSurcharge: unitSurcharge,
      }
    }
  })

  // Below is v2
  // ------------------------
  // if(!data.edges || data.edges.length === 0) {
  //     return [];
  // }
  //
  // return data.edges.map((discountData) => {
  //     const { Discount: paramountDiscount, Discount2: supplierDiscount, Product } = discountData.node;
  //     const { UnitPrice, CasePrice, ID } = Product;
  //
  //     const caseDiscount = Number(paramountDiscount) + Number(supplierDiscount);
  //     const unitDiscount = 0; // never have unit discount
  //     const hasDiscount = caseDiscount > 0 || unitDiscount > 0;
  //
  //     return {
  //         id: String(ID),
  //         case_discount: floorToTwoDecimals(caseDiscount),
  //         case_price: floorToTwoDecimals(CasePrice - caseDiscount),
  //         case_price_tax: 0,
  //         unit_discount: floorToTwoDecimals(unitDiscount),
  //         unit_price: floorToTwoDecimals(UnitPrice),
  //         unit_price_tax: 0,
  //         hasDiscount: hasDiscount,
  //     };
  // });

  // Below is v1
  // ------------------------
  // let newList = [];
  // let notFoundKeys = [];
  // const productsBasedOnProductID = {};
  // const productsInArray = Array.isArray(products) ? products : Object.values(products);
  //
  // productsInArray.map((item) => {
  //     if(item) {
  //         const { productID } = item;
  //
  //         if (typeof (productID) unitSurcharge!= 'undefined') {
  //             productsBasedOnProductID[productID] = item;
  //         }
  //     }
  // });
  //
  // Object.entries(list).map(([key, item]) => {
  //     const { product_price, product_tax, product_unit_price, product_unit_tax, frontline_case_final, sup_discount_min, frontline_unit_final, sup_discount_min_unit } = item;
  //
  //     if(typeof(productsBasedOnProductID[key]) != 'undefined') {
  //         const { id, sell_by_case } = productsBasedOnProductID[key];
  //
  //         const priceExists = productsBasedOnProductID[key] && productsBasedOnProductID[key].case_price;
  //         const casePrice = product_price ? Math.round(product_price * 100) / 100 : priceExists ? productsBasedOnProductID[key].case_price : 0;
  //         const caseDiscount = Math.round((frontline_case_final - sup_discount_min) * 100) / 100;
  //         const casePriceTax = product_tax ? Math.round(product_tax * 100) / 100 : 0;
  //         const unitPrice = sell_by_case ? 0 : Math.round(product_unit_price * 100) / 100;
  //         const unitDiscount = Math.round((frontline_unit_final - sup_discount_min_unit) * 100) / 100;
  //         const unitPriceTax = sell_by_case ? 0 : Math.round(product_unit_tax * 100) / 100;
  //
  //         newList.push({
  //             id: String(id),
  //             case_discount: caseDiscount,
  //             case_price: casePrice,
  //             case_price_tax: casePriceTax,
  //             unit_discount: unitDiscount,
  //             unit_price: unitPrice,
  //             unit_price_tax: unitPriceTax,
  //         });
  //     }
  //     else {
  //         notFoundKeys.push(key);
  //     }
  // });
  //
  // if(notFoundKeys.length) {
  //     console.log('The following keys were not found: ' + notFoundKeys.join('m, '));
  // }

  return newList
}
export const convertFrontlineProductsPricesToAReadableFormat = (list, user, products) => {
  const newList = []
  const notFoundKeys = []

  const productsBasedOnProductID = {}
  Object.entries(products).map(([key, item]) => {
    const { productID } = item
    productsBasedOnProductID[productID] = item
  })

  Object.entries(list).map(([key, item]) => {
    const { frontline_case_final, frontline_unit_final } = item

    if (typeof productsBasedOnProductID[key] !== 'undefined') {
      const { id, sell_by_case } = productsBasedOnProductID[key]

      const priceExists = productsBasedOnProductID[key] && productsBasedOnProductID[key].case_price
      const casePrice = frontline_case_final
        ? Number(frontline_case_final)
        : priceExists
        ? productsBasedOnProductID[key].case_price
        : 0
      const unitPrice = sell_by_case ? 0 : Number(frontline_unit_final)

      newList.push({
        id: String(id),
        case_price: casePrice,
        unit_price: unitPrice,
        originalCasePrice: casePrice,
        originalUnitPrice: unitPrice,
      })
    } else {
      notFoundKeys.push(key)
    }
  })

  if (notFoundKeys.length) {
    console.log('The following keys were not found: ' + notFoundKeys.join('m, '))
  }

  return newList
}

export const convertThreePlProductMaintenanceToAReadableFormat = (list, user, products) => {
  let newList = []
  let notFoundKeys = []
  let prodcutID
  const productsBasedOnProductID = {}
  Object.entries(products).map(([key, item]) => {
    const { productID, sku } = item
    productsBasedOnProductID[productID] = item

    Object.entries(list).map(([key, item]) => {
      const {
        StockAvailableMelbourne,
        StockAvailableSydney,
        StockAvailableBrisbane,
        StockAvailableCairns,
        StockAvailableAdelaide,
      } = item.node
      const { ID } = item.node.Product

      // if (typeof productsBasedOnProductID[key] != 'undefined') {
      if (productID == ID) {
        newList.push({
          id: String(ID),
          StockAvailableMelbourne: StockAvailableMelbourne,
          StockAvailableSydney: StockAvailableSydney,
          StockAvailableBrisbane: StockAvailableBrisbane,
          StockAvailableCairns: StockAvailableCairns,
          StockAvailableAdelaide: StockAvailableAdelaide,
        })
      }
      // } else {
      //   notFoundKeys.push(key)
      // }
    })
  })

  if (notFoundKeys.length) {
    console.log('The following keys were not found: ' + notFoundKeys.join('m, '))
  }

  return newList
}

export const convertIsSpecialToAReadableFormat = (list, products) => {
  const newList = []

  const productsBasedOnProductID = {}
  Object.entries(products).map(([key, item]) => {
    const { productID } = item
    productsBasedOnProductID[productID] = item
  })

  if (Array.isArray(list)) {
    list.map((key) => {
      if (typeof productsBasedOnProductID[key] !== 'undefined') {
        const { id } = productsBasedOnProductID[key]

        newList.push({
          id: String(id),
          isSpecial: true,
          hasDiscount: true,
        })
      }
    })
  }

  return newList
}
export const convertIsNewArrivalToAReadableFormat = (list, products) => {
  const newList = []

  const productsBasedOnProductID = {}
  Object.entries(products).map(([key, item]) => {
    const { productID } = item
    productsBasedOnProductID[productID] = item
  })

  if (Array.isArray(list)) {
    list.map((key) => {
      if (typeof productsBasedOnProductID[key] !== 'undefined') {
        const { id } = productsBasedOnProductID[key]

        newList.push({
          id: String(id),
          isNew: true,
        })
      }
    })
  }

  return newList
}
export const convertHasCocktailsToAReadableFormat = (list, products) => {
  const newList = []

  const productsBasedOnProductID = {}
  Object.entries(products).map(([key, item]) => {
    const { productID } = item
    productsBasedOnProductID[productID] = item
  })

  Object.entries(list).map((item) => {
    if (typeof productsBasedOnProductID[item.node.ID] !== 'undefined') {
      const { id } = productsBasedOnProductID[item.node.ID]

      newList.push({
        id: String(id),
        hasCocktails: convertToBoolean(item.node.HasCocktails),
      })
    }
  })

  return newList
}
export const convertCategoriesToAReadableFormat = (list) => {
  const newList = []

  Object.entries(list).map(([key, title]) => {
    newList.push({
      id: String(key),
      title: title,
    })
  })

  return newList
}
export const getProductSku = (sku) => {
  // return sku.toLowerCase() !== 'is null' ? sku : '';
  return sku && sku.toLowerCase() !== 'is null' ? sku : ''
}
export const extractProductSohFromRaw = (item) => {
  const { WHID1, WHQ1, WHID2, WHQ2, WHID3, WHQ3 } = item
  const soh = []

  if (WHID1) {
    soh[WHID1] = WHQ1
  }
  if (WHID2) {
    soh[WHID2] = WHQ2
  }
  if (WHID1) {
    soh[WHID3] = WHQ3
  }

  return soh
  // return JSON.stringify(soh);
}
// export const getProductSoh = (sohRaw, state, isCore) => {
//   if (!state) state = ''

//   let stock = 0

//   if (isCore) {
//     stock = sohRaw.vic
//   } else {
//     switch (state.toLowerCase()) {
//       case 'nsw':
//         stock = sohRaw.nsw
//         break
//       case 'sa':
//         stock = sohRaw.sa
//         break
//       default:
//         stock = sohRaw.vic
//     }
//   }

//   return stock > 0 ? stock : 0
// }
export const getProductCategoryInfoArray = (categoriesString) => {
  const categories = JSON.parse(categoriesString)
  const list = {}
  Object.entries(categories).map(([key, category]) => {
    list[key] = {
      id: key,
      // title: category
      title: key,
    }
  })
  return list
}
export const getProductCategoryIDArray = (categoriesString) => {
  const categories = JSON.parse(categoriesString)
  return Object.entries(categories).map(([key, category]) => key)
}

export const getProductURL = (URLSegment = '') => {
  return `/product/${URLSegment}`
}

export const getProductMaintenanceDetailURL = (id) => {
  return `/supplier/product-maintenance/edit/${id}`
}

export const getNiceFilterTitle = (name = '') => {
  switch (name.toLowerCase()) {
    case 'containertype':
      return 'Container Type'
    case 'loyaltypoint':
      return 'Point Range'
  }

  return name
}

export const buildLiquidFreightData = (detail, noticeItems, supplierID, asnEditID) => {
  const {
    dcLocation,
    stockBranchID,
    referenceNumber,
    contactEmail,
    freightSolution,
    pickUpLocation,
    reqDateOfPickUp,
    dcDeliveryDate,
    description,
    addressLine1,
    addressLine2,
    suburb,
    postCode,
    locationPhone,
    locationEmail,
    locationRunCode,
    numberOfPhysicalPallets,
    numberOfEquivalentPallets,
    loscamPallets,
    chepPallets,
    plainPallets,
  } = detail

  let newData = {}

  if (asnEditID) {
    newData.ID = asnEditID
  }
  newData.DCLocation = String(dcLocation) || ''
  newData.SupplierID = String(supplierID) || 0
  // newData.StockBranchID = stockBranchID || 0
  newData.ReferenceNumber = referenceNumber || ''
  newData.ContactEmail = contactEmail || ''
  newData.FreightSolution = freightSolution || ''
  newData.DCDeliveryDate = ''
  newData.PickUpLocation = pickUpLocation || ''
  newData.ReqDateOfPickUp = reqDateOfPickUp || ''
  newData.Description = description || ''
  newData.AddressLine1 = addressLine1 || ''
  newData.AddressLine2 = addressLine2 || ''
  newData.Suburb = suburb || ''
  newData.PostCode = postCode || ''
  newData.LocationPhone = String(locationPhone) || ''
  newData.LocationEmail = locationEmail || ''
  // newData.LocationRunCode = locationRunCode || ''
  // newData.NumberOfPhysicalPallets = numberOfPhysicalPallets || 0
  // newData.NumberOfEquivalentPallets = numberOfEquivalentPallets || 0
  newData.LoscamPallets = loscamPallets || 0
  newData.ChepPallets = chepPallets || 0
  newData.PlainPallets = plainPallets || 0
  newData.AdvancedShippingNoticeItems = noticeItems?.filter((item) => item.Carton !== null && item.Carton > 0)

  return newData
}

export const buildClientFreightData = (detail, noticeItems, supplierID, asnEditID) => {
  const {
    dcLocation,
    stockBranchID,
    referenceNumber,
    contactEmail,
    freightSolution,
    numberOfPhysicalPallets,
    numberOfEquivalentPallets,
    loscamPallets,
    chepPallets,
    plainPallets,
    dcDeliveryDate,
  } = detail
  let newData = {}

  if (asnEditID) {
    newData.ID = asnEditID
  }

  newData.DCLocation = String(dcLocation) || ''
  newData.SupplierID = String(supplierID) || 0
  // newData.StockBranchID = stockBranchID || 0
  newData.ReferenceNumber = referenceNumber || ''
  newData.ContactEmail = contactEmail || ''
  newData.FreightSolution = freightSolution || ''
  newData.DCDeliveryDate = dcDeliveryDate || ''
  newData.PickUpLocation = ''
  newData.ReqDateOfPickUp = ''
  newData.Description = ''
  newData.AddressLine1 = ''
  newData.AddressLine2 = ''
  newData.Suburb = ''
  newData.PostCode = ''
  newData.LocationPhone = ''
  newData.LocationEmail = ''
  // newData.LocationRunCode = ''
  // newData.NumberOfPhysicalPallets = numberOfPhysicalPallets || 0
  // newData.NumberOfEquivalentPallets = numberOfEquivalentPallets || 0
  newData.LoscamPallets = loscamPallets || 0
  newData.ChepPallets = chepPallets || 0
  newData.PlainPallets = plainPallets || 0
  newData.AdvancedShippingNoticeItems = noticeItems?.filter((item) => item.Carton !== null && item.Carton > 0)

  return newData
}

export const getProductMaintainencePricePostData = (orignal = [], modified = []) => {
  if (modified.length == 0) {
    return []
  }
  let newArray = []
  for (let i = 0; i < modified.length; i++) {
    let foundProduct = orignal.find((item) => item.BuyableID == modified[i].BuyableID)
    let newObj = {}
    if (
      foundProduct?.PriceAdl !== modified[i]?.PriceAdl ||
      foundProduct?.PriceBris !== modified[i]?.PriceBris ||
      foundProduct?.PriceMel !== modified[i]?.PriceMel ||
      foundProduct?.PriceSyd !== modified[i]?.PriceSyd ||
      foundProduct?.PriceCns !== modified[i]?.PriceCns
    ) {
      newObj['ProductID'] = modified[i]?.BuyableID
    }
    if (foundProduct?.PriceAdl !== modified[i]?.PriceAdl) {
      newObj['AdelaideCasePrice'] = Number(modified[i]?.PriceAdl)
    }
    if (foundProduct?.PriceBris !== modified[i]?.PriceBris) {
      newObj['BrisbaneCasePrice'] = Number(modified[i]?.PriceBris)
    }
    if (foundProduct?.PriceMel !== modified[i]?.PriceMel) {
      newObj['MelbourneCasePrice'] = Number(modified[i]?.PriceMel)
    }
    if (foundProduct?.PriceSyd !== modified[i]?.PriceSyd) {
      newObj['SydneyCasePrice'] = Number(modified[i]?.PriceSyd)
    }
    if (foundProduct?.PriceCns !== modified[i]?.PriceCns) {
      newObj['CairnsCasePrice'] = Number(modified[i]?.PriceCns)
    }
    newArray.push(newObj)
  }
  return newArray
}

export const applySplitCaseChargesToProductUnits = (list, charges) => {
  const newList = list || []

  for (let element of newList) {
    let foundProduct = charges.find((charge) => charge?.ProductType == element?.webCategory)

    if (element?.unit_price && foundProduct?.Rate) {
      let priceAfterSubChange = element?.unit_price * (1 + foundProduct?.Rate)
      element['unit_price'] = priceAfterSubChange
    }
    newList.push(element)
  }

  return newList
}
